<template>
  <base-container
    ref="container"
    style="display: flex; overflow: hidden"
    :isLoading="loading"
  >
    <div style="width: 30%; overflow-y: auto; margin-left: 10px">
      <artisan-group border>
        <el-row slot="header">
          <el-col :span="12" class="color-danger">
            <b class="text-small">其他(待分配)</b>
          </el-col>
          <el-col :span="6" class="text-mini color-danger">
            <b class="text-small">{{ otherMember.queueItems.queueSize }}</b>
            (排队数)
          </el-col>
        </el-row>
        <div class="padding7">
          <draggable
            :animation="340"
            :list="otherMember.queueItems"
            handle=".movable"
            group="queueItem"
          >
            <TransitionGroup style="min-height: 30px; display: block">
              <el-row
                type="flex"
                class="movable queue-item-info"
                justify="space-between"
                align="middle"
                v-for="(item, i) in otherMember.queueItems"
                :key="i"
                @click.native="changePatient(item, otherMember)"
              >
                <span>
                  <i v-if="editable" class="el-icon-s-operation"></i>
                  <b>
                    {{ i + 1 + "." + item.patientName }}
                  </b>
                  <span style="font-size: 10px; margin: 0 5px">
                    {{ item.patientGender == "M" ? "男" : "女" }}
                  </span>
                  <span
                    v-if="item.noticeCount"
                    style="font-size: 10px; margin: 0 5px"
                  >
                    通知次数:{{ item.noticeCount }}
                  </span>
                </span>
              </el-row>
            </TransitionGroup>
          </draggable>
        </div>
      </artisan-group>
    </div>
    <div style="height: 100%; width: 30%; margin: 0 5px">
      <div
        style="
          height: calc(100% - 35px);
          overflow-y: auto;
          border: 0.5px solid #1989fa;
          padding: 0 5px;
        "
      >
        <artisan-group>
          <el-row slot="header">
            <el-col :span="12" class="color-primary">
              <b class="text-small">{{ data.name }}</b>
              <span class="text-mini">(组长)</span>
            </el-col>
            <el-col :span="6" class="text-mini color-danger">
              <b class="text-small">{{ data.queueSize }}</b>
              (排队数)
            </el-col>
            <el-col :span="6" class="text-mini color-warning">
              <el-popover placement="bottom-start" trigger="hover">
                <el-table :data="data.idles" size="mini">
                  <el-table-column
                    width="100"
                    property="idleDate"
                    label="日期"
                    header-align="center"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    width="80"
                    property="useCount"
                    label="总空床数"
                    header-align="center"
                    align="center"
                  >
                    <span slot-scope="{ row }">
                      <b class="color-success text-large">{{ row.idleCount }}</b
                      >(-{{ row.useCount }})
                    </span>
                  </el-table-column>
                  <el-table-column
                    width="80"
                    property="useCount"
                    label="男空床数"
                    header-align="center"
                    align="center"
                  >
                    <span slot-scope="{ row }">
                      <b class="color-primary text-large">{{ row.manCount }}</b
                      >(-{{ row.manUseCount }})
                    </span>
                  </el-table-column>
                  <el-table-column
                    width="80"
                    property="useCount"
                    label="女空床数"
                    header-align="center"
                    align="center"
                  >
                    <span slot-scope="{ row }">
                      <b class="color-danger text-large">{{ row.womenCount }}</b
                      >(-{{ row.womenUseCount }})
                    </span>
                  </el-table-column>
                </el-table>
                <span slot="reference" style="text-decoration: underline">
                  <b class="text-small"> {{ data.idleTotal }} </b>
                  (空床数)
                </span>
              </el-popover>
            </el-col>
          </el-row>
          <div class="padding7">
            <draggable
              :animation="340"
              :list="data.queueItems"
              handle=".movable"
              group="queueItem"
            >
              <TransitionGroup style="min-height: 30px; display: block">
                <el-row
                  class="movable"
                  type="flex"
                  justify="space-between"
                  align="middle"
                  :class="getRowClass(item, i, data)"
                  v-for="(item, i) in data.queueItems"
                  :key="i"
                  @click.native="changePatient(item, data)"
                >
                  <span>
                    <i v-if="editable" class="el-icon-s-operation"></i>
                    <b>
                      {{ i + 1 + "." + item.patientName }}
                    </b>
                    <span style="font-size: 10px; margin: 0 5px">
                      {{ genderLabel(item.patientGender) }}
                    </span>
                    <span
                      v-if="item.noticeCount"
                      style="font-size: 10px; margin: 0 5px"
                    >
                      通知次数:{{ item.noticeCount }}
                    </span>
                  </span>
                  <span
                    v-if="notifiable(item, i, data)"
                    :class="
                      queueIds.indexOf(item.id) >= 0
                        ? 'artisan-input-checked'
                        : 'artisan-input-uncheck'
                    "
                    class="clickable"
                    @click="checkQueue(item.id)"
                  >
                    <i class="el-icon-check"> </i>
                  </span>
                </el-row>
              </TransitionGroup>
            </draggable>
          </div>
        </artisan-group>
        <template v-for="member in data.members">
          <artisan-group
            :key="member.id"
            v-if="member.id != '0'"
            style="margin: 10px 0"
          >
            <el-row slot="header">
              <el-col :span="12" class="color-primary">
                <b class="text-small">{{ member.name }}</b>
                <span v-if="member.id !== '0'" class="text-mini">(组员)</span>
              </el-col>
              <el-col :span="6" class="text-mini color-danger">
                <b class="text-small">{{ member.queueSize }}</b>
                (排队数)
              </el-col>
              <el-col :span="6" class="text-mini color-warning">
                <el-popover placement="bottom-start" trigger="hover">
                  <el-table :data="member.idles" size="mini">
                    <el-table-column
                      width="100"
                      property="idleDate"
                      label="日期"
                      header-align="center"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      width="80"
                      property="useCount"
                      label="总空床数"
                      header-align="center"
                      align="center"
                    >
                      <span slot-scope="{ row }">
                        <b class="color-success text-large">{{
                          row.idleCount
                        }}</b
                        >(-{{ row.useCount }})
                      </span>
                    </el-table-column>
                    <el-table-column
                      width="80"
                      property="useCount"
                      label="男空床数"
                      header-align="center"
                      align="center"
                    >
                      <span slot-scope="{ row }">
                        <b class="color-primary text-large">{{
                          row.manCount
                        }}</b
                        >(-{{ row.manUseCount }})
                      </span>
                    </el-table-column>
                    <el-table-column
                      width="80"
                      property="useCount"
                      label="女空床数"
                      header-align="center"
                      align="center"
                    >
                      <span slot-scope="{ row }">
                        <b class="color-danger text-large">{{
                          row.womenCount
                        }}</b
                        >(-{{ row.womenUseCount }})
                      </span>
                    </el-table-column>
                  </el-table>
                  <span slot="reference" style="text-decoration: underline">
                    <b class="text-small">{{ member.idleTotal }}</b>
                    (空床数)
                  </span>
                </el-popover>
              </el-col>
            </el-row>
            <div class="padding7">
              <draggable
                :animation="340"
                :list="member.queueItems"
                handle=".movable"
                group="queueItem"
              >
                <TransitionGroup style="min-height: 30px; display: block">
                  <el-row
                    class="movable"
                    type="flex"
                    justify="space-between"
                    align="middle"
                    :class="getRowClass(item, i, member)"
                    v-for="(item, i) in member.queueItems"
                    :key="i"
                    @click.native="changePatient(item, member)"
                  >
                    <span>
                      <i v-if="editable" class="el-icon-s-operation"></i>
                      <b>
                        {{ i + 1 + "." + item.patientName }}
                      </b>
                      <span style="font-size: 10px; margin: 0 5px">
                        {{ genderLabel(item.patientGender) }}
                      </span>
                      <span
                        v-if="item.noticeCount"
                        style="font-size: 10px; margin: 0 5px"
                      >
                        通知次数:{{ item.noticeCount }}
                      </span>
                    </span>
                    <span
                      v-if="notifiable(item, i, member)"
                      :class="
                        queueIds.indexOf(item.id) >= 0
                          ? 'artisan-input-checked'
                          : 'artisan-input-uncheck'
                      "
                      class="clickable"
                      @click="checkQueue(item.id)"
                    >
                      <i class="el-icon-check"> </i>
                    </span>
                  </el-row>
                </TransitionGroup>
              </draggable>
            </div>
          </artisan-group>
        </template>
      </div>
      <div
        v-if="editable"
        style="
          text-align: center;
          background-color: white;
          padding-top: 5px;
          height: 35px;
        "
      >
        <el-button
          icon="el-icon-check"
          size="mini"
          type="primary"
          @click="saveWardGroup"
        >
          保存
        </el-button>
        <el-button
          icon="el-icon-circle-check"
          :disabled="!queueIds.length"
          size="mini"
          type="success"
          @click="verifyNotify"
        >
          审核并通知
        </el-button>
      </div>
    </div>
    <div style="height: 100%; flex: 1">
      <div style="height: calc(100% - 35px); overflow-y: auto">
        <artisan-group title="入院卡信息">
          <RecordDetail
            v-show="record.id"
            :key="record.id"
            :record="record"
          ></RecordDetail>
        </artisan-group>
      </div>
      <div
        v-if="editable"
        style="
          text-align: center;
          background-color: white;
          padding-top: 5px;
          height: 35px;
        "
      >
        <el-button
          v-if="record.obeyAdjustGroup"
          icon="el-icon-edit-outline"
          size="mini"
          type="warning"
          @click="showWardGroup()"
        >
          调组
        </el-button>
        <el-button
          v-if="record.obeyAdjustHos"
          icon="el-icon-edit-outline"
          size="mini"
          type="danger"
          @click="showWardGroup()"
        >
          调院区
        </el-button>
      </div>
    </div>
    <artisan-drawer
      title="调整"
      :visible.sync="show"
      direction="right"
      size="40%"
      ref="drawer"
      :isLoading="drawerLoading"
    >
      <WardGroup
        ref="wardGroup"
        v-if="show"
        :wardId="record.reserveWardId"
        :isHos="record.obeyAdjustHos"
        :hos-id="record.reserveHosId"
      ></WardGroup>
      <template #footer>
        <el-button
          icon="el-icon-check"
          size="mini"
          type="success"
          @click="confirmAdjust"
        >
          确定
        </el-button>
      </template>
    </artisan-drawer>
  </base-container>
</template>

<script>
import draggable from "vuedraggable";
import { verifyWardGroup, sortWardGroup } from "@/api/bed/ward";
import { adjust } from "@/api/bed/record";
import RecordDetail from "./RecordDetail.vue";
import WardGroup from "./WardGroup.vue";
export default {
  components: { draggable, RecordDetail, WardGroup },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          queueItems: [],
          records: [],
          idles: [],
          members: [],
        };
      },
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      drawerLoading: false,
      show: false,
      queueItem: {},
      record: {},
      queueIds: [],
    };
  },
  computed: {
    otherMember() {
      let otherMember = this.data.members.find((c) => c.id == "0");
      return Object.assign(
        { queueItems: [], queueSize: 0, members: [], records: [] },
        otherMember
      );
    },
  },
  methods: {
    genderLabel(gender) {
      let label = "未知";
      switch (gender) {
        case "1":
          label = "男";
          break;
        case "2":
          label = "女";
          break;
      }
      return label;
    },
    notifiable(item, i, member) {
      return i + 1 <= member.idleTotal && this.editable;
    },
    getRowClass(item, i, member) {
      if (item.inlineRemark) {
        return "queue-item-danger";
      } else {
        if (i + 1 <= member.idleTotal) {
          return "queue-item-success";
        }
        return "queue-item-info";
      }
    },
    changePatient(item, member) {
      this.record = member.records.find((c) => c.id == item.recordId);
    },
    checkQueue(queueId) {
      let index = this.queueIds.indexOf(queueId);
      if (index >= 0) {
        this.queueIds.splice(index, 1);
      } else {
        this.queueIds.push(queueId);
      }
    },
    saveWardGroup() {
      let data = {
        wardId: this.data.wardId,
        queueIds: this.queueIds,
        queues: [],
      };
      this.data.queueItems.forEach((c, i) => {
        if (c.sortNo != i + 1 || c.doctorId != this.data.id) {
          c.sortNo = i + 1;
          c.doctorId = this.data.id;
          c.doctorName = this.data.name;
          data.queues.push(c);
        }
      });
      this.data.members.forEach((m) => {
        m.queueItems.forEach((c, i) => {
          if (c.sortNo != i + 1 || c.doctorId != m.id) {
            c.sortNo = i + 1;
            c.doctorId = m.id;
            c.doctorName = m.name;
            data.queues.push(c);
          }
        });
      });
      this.$refs.container.confirm({ msg: "确认保存？" }).then(() => {
        sortWardGroup(data).then((res) => {
          this.$message({ type: "success", message: "操作成功！" });
          this.$emit("sorted");
        });
      });
    },
    verifyNotify() {
      let data = {
        wardId: this.data.wardId,
        queueIds: this.queueIds,
        queues: [],
      };
      this.data.queueItems.forEach((c, i) => {
        if (c.sortNo != i + 1 || c.doctorId != this.data.id) {
          c.sortNo = i + 1;
          c.doctorId = this.data.id;
          c.doctorName = this.data.name;
          data.queues.push(c);
        }
      });
      this.data.members.forEach((m) => {
        m.queueItems.forEach((c, i) => {
          if (c.sortNo != i + 1 || c.doctorId != m.id) {
            c.sortNo = i + 1;
            c.doctorId = m.id;
            c.doctorName = m.name;
            data.queues.push(c);
          }
        });
      });
      this.$refs.container.confirm({ msg: "确认审核并通知？" }).then(() => {
        verifyWardGroup(data).then(() => {
          this.$message({ type: "success", message: "操作成功！" });
          this.$emit("verified");
        });
      });
    },
    showWardGroup() {
      this.show = true;
    },
    confirmAdjust() {
      let wardGroupId = this.$refs.wardGroup.getSelGroupId();
      if (!wardGroupId) {
        this.$message({
          type: "warning",
          message: "请现在需要调整的医疗组！",
        });
      }
      this.$refs.drawer.confirm({ msg: "确认要调整医疗组？" }).then((res) => {
        this.drawerLoading = true;
        adjust(this.record.id, wardGroupId)
          .then((res) => {
            this.$message({
              type: "success",
              message: "调整成功！",
            });
            this.show = false;
            this.drawerLoading = false;
            this.$emit("adjust");
          })
          .catch(() => {
            this.drawerLoading = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.queue-item-success {
  /* background-color: #67c23a; */
  border-color: #67c23a;
  color: #67c23a;
  padding: 7px;
  margin: 3px 0;
  border: 1px solid #67c23a;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  cursor: pointer;
}
.queue-item-danger {
  /* background-color: #f56c6c; */
  border-color: #f56c6c;
  color: #f56c6c;
  padding: 7px;
  margin: 3px 0;
  border: 1px solid #f56c6c;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  cursor: pointer;
}
.queue-item-info {
  /* background-color: #909399; */
  border-color: #909399;
  color: #909399;
  padding: 7px;
  margin: 3px 0;
  border: 1px solid #909399;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  cursor: pointer;
}
</style>
